export const uuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8; // eslint-disable-line eqeqeq
    return v.toString(16);
  });

export const required = (value: string) => `${value}*`;

export const safeParse = <T>(json?: string | null | undefined) => {
  try {
    return json ? (JSON.parse(json) as T) : undefined;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const debug = <T>(value: T, message?: string) => {
  console.log(value, message);
  return value;
};

export const download = (url: string, filename?: string) => {
  if (document) {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = filename || url.split('/').pop()!;
    a.click();
  }
};

export const preloadImage = (image: string) =>
  new Promise((resolve, reject) => {
    try {
      const img = new Image();
      img.src = image;
      img.onload = resolve;
      img.onerror = reject;
    } catch (error) {
      reject(error);
    }
  });

const siteUrl = process.env.GATSBY_SITE_URL;

export const absoluteUrl = (path: string) => {
  return path.startsWith('http') ? path : `${siteUrl}${path}`;
};

export const detectSafari = () => {
  return typeof navigator !== 'undefined'
    ? navigator.vendor &&
        navigator.vendor.includes('Apple') &&
        !navigator.userAgent.includes('CriOS') &&
        !navigator.userAgent.includes('FxiOS')
    : false;
};
